import React from 'react'
import './FormSectionHeader.css'

export default function FormSectionHeader({ text }) {
    return (<div className='form-section-header'>{ text }</div>)
}